import React, { Component } from 'react';
import ReactHtmlParser from 'react-html-parser';
import LoadingOverlay from 'react-loading-overlay';
import moment from 'moment';
import 'bootstrap/dist/css/bootstrap.css';
import { IoIosArrowBack,IoIosArrowForward } from "react-icons/io";
import {FeedingController} from '../controllers/Feeding';

export const ReactCalender = class ReactCalender extends Component {
  state = { 
    dateObject: moment(),
    selectedDate: "",
    showMessage: false,
    suggestions: [],
    suggestion: {},
    events_dates: [],
    loading: true,
    error: null,
  }

  weekdayshort = moment.weekdaysShort();

  firstDayOfMonth = () =>{
    let dateObject = this.state.dateObject;
    let firstDay = moment(dateObject).startOf("month").format("d");
    return firstDay;   
  }

  daysInMonth = () => {
    return this.state.dateObject.daysInMonth();
  }

  month = () => {
    return this.state.dateObject.format("MMMM");
  };

  monthNo = () => {
    return this.state.dateObject.format("M");
  };

  year = () => {    
    return this.state.dateObject.format("Y");
  };

  onPrev = () => {
    let curr = "";
    if (this.state.showYeahTable == true) {
      curr = "year";
    } else {
      curr = "month";
    }
    this.setState({
      dateObject: this.state.dateObject.subtract(1, curr)
    });
  };

  onNext = () => {
    let curr = "";
    if (this.state.showYeahTable == true) {
      curr = "year";
    } else {
      curr = "month";
    }
    this.setState({
      dateObject: this.state.dateObject.add(1, curr)
    });
  };
  currentDay = () => {  
    return this.state.dateObject.format("D");
  };

  hideAdvice = () => {
    this.setState({showMessage: false});
  }

  getAdvice = () => {
    const { suggestions, selectedDate } = this.state;

    suggestions.some((data) => {
      const recording_time = new Date(data['recording_time']);
      const recording_year = recording_time.getFullYear();
      var recording_month = recording_time.getMonth();
      recording_month += 1;
      recording_month = recording_month < 10 ? '0'+recording_month : recording_month;
      const recording_day = recording_time.getDate() < 10 ? '0'+recording_time.getDate() : recording_time.getDate();
      const recording_date = recording_year+'-'+recording_month+'-'+recording_day;
      if(recording_date === selectedDate){
        this.setState({suggestion: data, showMessage: true});
        return true;
      }
    });

  }

  onDayClick = (e, d) => { 
    const state = this.state;
    const day = d < 10 ? "0"+d : d;
    var month = this.state.dateObject.format("M");
    month = month < 10 ? "0"+month: month;
    const year = this.state.dateObject.format("Y");
    const date = year+"-"+month+"-"+day;
    state.selectedDate = date;
    this.setState(state);
    this.getAdvice();
  };

  setData = () => {
    const { Child, User } = this.props;
    FeedingController.getFeedingSuggestions(Child, User).then((res) => {
      if(res.success)
        this.setState({events_dates: res.data.advice_dates, suggestions: res.data.advice_records,loading: false, error: res.error});
      else
        this.setState({loading: false, error: res.error});

      }).catch((error) => {
        alert(error);
    });
  }

  componentDidMount() {
    this.setData();
  }

  render() {
    const { loading, events_dates, suggestions, suggestion, showMessage, error } = this.state;
    const { Child, Translator } = this.props;
    const translation = Translator;
    let weekdayshortname = this.weekdayshort.map(day =>{
      return (
      <th key={day} className="week-day">{day}</th>
      );
    });
    let blank = [];
    for (let j = 0; j < this.firstDayOfMonth(); j++) {
        blank.push(<td>{""}</td>)      
    };
    let monthDays = [];
    let activeYear = this.year();
    let activeMonth = this.monthNo() < 10 ? '0'+this.monthNo() : this.monthNo();
    for (let d = 1; d <= this.daysInMonth(); d++) {
      let activeDay = d < 10 ? '0'+d : d;
      let activeDate = activeYear+'-'+activeMonth+'-'+activeDay;
      let currentDay = d == this.currentDay() ? "today" : "";
      // events_dates.forEach((date) => {
      if(events_dates.includes(activeDate)){
        monthDays.push(<td onClick={e => { 
          this.onDayClick(e, d);
        }} key={d} className={`calendar-day ${currentDay}`} style = {{cursor: "pointer"}}><span style={{backgroundColor: "hsl(120, 50%, 40%)", width: "20px", height: "20px",padding: "5px",borderRadius: "50%",fontSize: "0.8em",color: "#fff"}}>
            {d}
          </span></td>
        )
      }
      else
        monthDays.push(<td key={d} className={`calendar-day ${currentDay}`}><span>
          {d}
        </span></td>
        )

      // });    
    }
    var totalSlots = [...blank,...monthDays];
    let rows = [];
    let cells = [];
    totalSlots.forEach((row,j) =>{
        if (j % 7 !== 0) {
            cells.push(row)
        }else{
            rows.push(cells)
            cells = []
            cells.push(row)
        }
        if (j === totalSlots.length - 1) {
            rows.push(cells) 
        }
    })
        
    let daysinMonth = rows.map((d,j) =>{
      return <tr style={{textAlign: "center"}} >{d}</tr>
    })
    return ( 
      <div className="main">
        <LoadingOverlay active={loading} spinner text='Fetching data...'>
          <div>
            <div className="container-fluid">
              <div className="row">
                <div className="col-12 col-sm-12 col-md-6 offset-md-3 pt-5">
                  <div className="card-title text-center">
                    {translation['feeding_advice_title']}
                  </div>
                  <table className="table table-bordered">
                    <tr>
                      <td><button onClick={e =>{this.onPrev()}} style={{float:'left',fontSize: '1.3em',border: '0px',backgroundColor: '#fff',outline: 'none'}}><span><IoIosArrowBack/></span></button></td>
                      <td colSpan="5" className="text-center">{this.month()}&nbsp;{this.year()}</td>
                      <td><button onClick={e =>{this.onNext()}}  style={{float:'right',fontSize: '1.3em',border: '0px',backgroundColor: '#fff',outline: 'none'}}><span><IoIosArrowForward/></span></button></td>
                    </tr>
                    <tr>{weekdayshortname}</tr>
                    <tbody>{daysinMonth}</tbody>
                  </table>
                </div>
              </div>
            </div>
            {showMessage ? (
              <div className="feeding_advice" style={{height: "auto",position: "absolute",top: "170px",backgroundColor: "#fff",right: "37px",left: "37px",bordeRadius: "10px",zIndex: "1024",boxShadow: "5px 5px 5px 5px #888888",padding: "10px 10px",fontFamily: "Abel",marginBottom: "20px"}}>
                <h5 style={{textAlign: "center"}}>{suggestion['recording_time']}</h5>
                <div style = {{height: "250px", overflow: "scroll"}}>
                  {(suggestion['bmi_warning']!='' || suggestion['bmi_message']!='') ? (
                  <div>
                  <h4 style={{textAlign: "center"}}>{translation['feeding_advice_weight_height_title']}</h4>
                  <p className="alert-success">
                    <h5 style={{textAlign: "center"}}>{ReactHtmlParser(suggestion['bmi_message'])}</h5>
                  </p>
                  <p className="alert-danger">
                    <h5 style={{textAlign: "center"}}>{ReactHtmlParser(suggestion['bmi_warning'])}</h5>
                  </p>
                    </div>
                  ) : null}
                  <h4 style={{textAlign:"center"}}>{translation['feeding_advice_sub_title']}</h4>
                    {(suggestion['feeding_message']=='' && suggestion['feeding_warning']=='') ? (
                      <p className="alert-info">
                        {translation['feeding_advice_no_advice']}
                      </p>
                    ) : (
                      <div>
                        <p className="alert-success">
                          {ReactHtmlParser(suggestion['feeding_message'])}
                        </p>
                        <p className="alert-warning">
                          {ReactHtmlParser(suggestion['feeding_warning'])}
                        </p>
                      </div>
                    )}
                  </div>
                  <div onClick = {this.hideAdvice} style={{textAlign: "right",marginRight: "20px"}}><button type="button" style={{width: "70px",height: "35px"}} id="hide_advice">OK</button></div>
              </div>
            ) : null}
          </div>
        </LoadingOverlay>
        {/* ) : (<div style = {{textAlign: "center"}}>Fetching data...</div>) } */}
      </div>
    );
  }
}
 
export default ReactCalender;